import React from 'react';
import styled from '@emotion/styled';
import useSimplePortal from './useSimplePortal';

const DrawerWrapper = styled.div`
    background-color: #ebfcff;
    border: 1px solid #0094AB;
    border-cottom: 0;
    border-top: 0;
    padding: 10px;
    padding-left: 50px;
    padding-right: 20px;
    ${props => props.show ? '' : 'display: none;' }
`

const DrawerText = styled.span`
    line-height: 2;
    color: #0094AB;
    font-weight: 500;
`

const DrawerButtons = styled.span`
    float: right;
`

export default function UndoCancellationLink({ date, onClickUndo, onClickYes, onClickNo, drawerOpen }) {
    return (
        <div>
            <a href="javascript:;" className="button small delete disabled" style={{ marginLeft: '0px', pointerEvents: 'all', marginBottom: '10px' }}>
                <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.44981 1.00005L8.44981 0.300049L3.6498 6.80005L1.4498 4.50005L0.549805 5.40005L3.8498 8.70005L9.44981 1.00005Z" fill="white"/>
                </svg>
                &nbsp; Cancellation Sent
            </a>
            <div style={{ fontSize: '13px' }}>
                Request Sent on {date}&nbsp;|&nbsp;
                <span>
                    <a href="javascript:;" title="Undo" onClick={onClickUndo}>Undo</a>
                    {useSimplePortal(
                        <DrawerWrapper show={drawerOpen}>
                            <DrawerText>This will resume payment, do you wish to proceed?</DrawerText>
                            <DrawerButtons>
                                <a onClick={onClickNo} className="button transparent small">NO</a>
                                <a href="javascript:;" onClick={onClickYes} className="button primary small">YES</a>
                            </DrawerButtons>
                        </DrawerWrapper>,
                        '#undo-cancellation-drawer'
                    )}
                </span>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/PaymentCancellation/UndoCancellationLink.jsx